import {
  defineClientExperiment,
  type ClientExperiment,
} from '@lib/client-experiments';

export const topNavSimplification = defineClientExperiment({
  name: 'top_nav_simplification',
  cohorts: [
    { name: 'control', percentage: 50 },
    { name: 'test', percentage: 50 },
  ],
  isActive: true,
  isEnrolling: true,
  attribute: 'data-top-nav',
});

export const clientExperiments: ClientExperiment[] = [topNavSimplification];
